import { render, staticRenderFns } from "./UserHelpArticle.vue?vue&type=template&id=06f4597c&"
import script from "./UserHelpArticle.vue?vue&type=script&lang=ts&"
export * from "./UserHelpArticle.vue?vue&type=script&lang=ts&"
import style0 from "./UserHelpArticle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports